interface IsLaunchDarklyNetworkErrorParams {
  message: string
}

/**
 * True for a transient LaunchDarkly flag-fetch network failure — the SDK's
 * `Requestor` rejects with an `LDFlagFetchError` whose message is `network error (...)`
 * when the browser `fetch` never receives a response (dropped connection, backgrounded
 * tab). Non-actionable: the flag store keeps its bootstrapped/last-known values.
 *
 * Deliberately narrow: matches only the network message, not HTTP-status or
 * invalid-context errors (which start differently), so genuine misconfiguration
 * still surfaces.
 */
export const isLaunchDarklyNetworkError = ({ message }: IsLaunchDarklyNetworkErrorParams): boolean =>
  message.startsWith('network error')
